/** cubed™ Stripe */
var cubedStripe = {

	amount:					null, // Leave as null which assumes you caluclate the amount server-side, otherwise set an amount (the latter useful for online donations, for exmaple)
	stripe:					null,
	elements: 				null,
	$form: 					null,
	sessionToken:			null,
	cardErrors:				{},
	generalError:			'An error occured processing the payment',
	serverError:			'A server error occured so please contact us to check whether your payment went through',
	cardSetupError:			'An error occured verifying your card; check the details and try again', // Card SetupIntent error; there are a few of these but are not suitable to show the user as is
	onGeneralError:			($form, message) => { alert(message); },
	onServerError:			($form, message) => { alert(message); },
	onSuccess:				($form, paymentIntentID, customData) => {},
	onPaymentStart:			($form) => {},
	getShowIntentData:		() => { return {}; },
	paymentMethodEleme:		null,
	paymentMethod:			null,
	cardClassNames:	{

		number: 'card-number',
		expiry: 'card-expiry',
		cvc: 	'card-cvc'

	},
	cardBillingFormNames: {

		name: 	'name',
		email:	'email',
		phone: 	'phone',
		address: {

			line1: 		'address-line-1',
			line2: 		'address-line-2',
			town: 		'town',
			county: 	'county',
			postcode: 	'postcode',
			country:	'country'

		}

	},
	handleServerResponse: function(data) {
		
		console.log('handleServerResponse');
		console.log(data);

		// This is only ever called via done() so the HTTP code is OK by this point

		var _self = this;

		if (typeof data.valid === 'undefined') {

			// Malformed response, this shouldn't ever be called but handle just in case
			_self.onServerError(_self.$form, _self.serverError);

		} else if (data.valid == 'action') {

			// Use Stripe.js to handle required card action
			_self.handleAction(data.intent);


		} else if (data.valid == 'done') {

			_self.onSuccess(_self.$form, data.intent, data.custom);

		} else {

			// Malformed response, this shouldn't ever be called but handle just in case
			_self.onServerError(_self.$form, _self.serverError);

		}

	},
	handleAction: function(response) {

		var _self = this;

		_self.stripe.handleCardAction(response)
		            .then(function(result) {

			if (result.error) {

				// Error (using Stripe error code): Stripe error handling the card
				_self.onGeneralError(_self.$form, _self.getError(result.error.code));

			} else {

				$.ajax({

					type: 'POST',
					url: _self.path,
					data: {
						
						// Use same format as initial call
						twire: JSON.stringify({

							sessionToken: 	_self.sessionToken,
							token:   		result.paymentIntent.id,
							confirm: 		1

						})
						
					}

				}).done(function(response) {

					_self.handleServerResponse(response.data);

				}).fail(function(jqXHR, textStatus, errorThrown) {
					
					console.log(jqXHR);
					
					// Allow an overriding message to be set; useful for form validation and custom errors
					if (typeof jqXHR.responseJSON !== 'undefined' && typeof jqXHR.responseJSON.message !== 'undefined') {
						
						_self.onGeneralError(_self.$form, jqXHR.responseJSON.message);
						
					} else {
						
						if (typeof jqXHR.responseJSON             !== 'undefined' &&
							typeof jqXHR.responseJSON.data    	  !== 'undefined' &&
						    typeof jqXHR.responseJSON.data.intent !== 'undefined') {

							if (jqXHR.responseJSON.data.intent == '_server') {

								// .intent is not said so assume a server error
								_self.onServerError(_self.$form, _self.serverError);

							} else {

								// .intent should be a Stripe card error code
								_self.onGeneralError(_self.$form, _self.getError(jqXHR.responseJSON.data.intent));

							}

						} else {

							// .intent is not said so assume a server error
							_self.onServerError(_self.$form, _self.serverError);

						}
						
					}
					
				});

			}

		});

	},
	getError(code) {

		// card_errors from Stripe are stored in stripe-card-errors.json and are shown to the user as specific errors
		// (they can be overidden after init() if they need to be translated

		// There are two other errors:
		// _general: nothing has gone wrong with this site but the payment has failed (e.g. Stripe API down)
		// _server:  something has gone wrong with this server
		
		// Additionally, _custom can be sent for error messages set by the server (useful for form validation)
		// When returing custom error set 400 for general errors and 500 for server errors

		// General and server are both used in the script implicitly but the API can also choose to return
		// [valid => error, intent => _general|_server] if needed

		// In production something major would have gone wrong to trigger a _server error (e.g. database down)
		// and so they should be handle differently

		var _self = this;

		// Check if it is a card error, otherwise display the default error
		var error = _self.generalError;

		console.log('Sent ' + code);

		for (var property in _self.cardErrors) {

			if (_self.cardErrors.hasOwnProperty(property)) {

				if (property == code) {

					error = _self.cardErrors[property];

				}

			}

		}

		return error;

	},
	// TODO setUpCardForm
	initElements: function(apiKey, elementsConfig, style) {

		var _self		= this;
		_self.stripe 	= Stripe(apiKey);
		_self.elements 	= _self.stripe.elements(elementsConfig);

		_self.paymentMethodElement = _self.elements.create('cardNumber', { style: style });
		_self.paymentMethodElement.mount('.' + _self.cardClassNames.number);

		_self.elements.create('cardExpiry', { style: style }).mount('.' + _self.cardClassNames.expiry);
		_self.elements.create('cardCvc',    { style: style }).mount('.' + _self.cardClassNames.cvc);

	},
	init: function($form, apiKey, sessionToken, elementsConfig, style) {

		var _self			= this;
		_self.$form			= $form;
		_self.sessionToken  = sessionToken; // Used in the session to persist meta data, etc across show and confirm requests
		_self.cardErrors	= require('../json/stripe-card-errors.json');

		_self.initElements(apiKey, elementsConfig, style);

	},
	processPayment: function(path, metaData, customer = '', save = false, paymentMethodID = '') {

		// Convert to 0|1
		save = save === true ? '1' : '0';

		var _self = this;

		_self.path = path;

		_self.onPaymentStart(_self.$form);

		// If a payment method ID is set skip the tokenising since it's from a saved card
		if (paymentMethodID !== '') {

			_self.paymentMethod = paymentMethodID;

			_self.sendPaymentMethod(metaData, customer, save);

		} else {

			_self.stripe.createPaymentMethod('card', _self.paymentMethodElement, {

				billing_details: {

					name: 	_self.$form.find('[name="' + _self.cardBillingFormNames.name  + '"]').val(),
					email:	_self.$form.find('[name="' + _self.cardBillingFormNames.email + '"]').val(),
					phone: 	_self.$form.find('[name="' + _self.cardBillingFormNames.phone + '"]').val(),
					address: {

						line1: 			_self.$form.find('[name="' + _self.cardBillingFormNames.address.line1    + '"]').val(),
						line2: 			_self.$form.find('[name="' + _self.cardBillingFormNames.address.line2    + '"]').val(),
						city: 			_self.$form.find('[name="' + _self.cardBillingFormNames.address.town     + '"]').val(),
						state: 			_self.$form.find('[name="' + _self.cardBillingFormNames.address.county   + '"]').val(),
						postal_code: 	_self.$form.find('[name="' + _self.cardBillingFormNames.address.postcode + '"]').val(),
						country:		_self.$form.find('[name="' + _self.cardBillingFormNames.address.country  + '"]').val()

					}

				}

			}).then(function(result) {

				if (result.error) {

					// Error (using Stripe error code): payment method
					_self.onGeneralError(_self.$form, _self.getError(result.error.code));

				} else {

					_self.paymentMethod = result.paymentMethod.id;

					_self.sendPaymentMethod(metaData, customer, save);

				}

			});

		}

	},
	sendPaymentMethod: function(metaData, customer, save, paymentMethodID) {

		var _self = this;
		
		_self.$form.find('input[name="twire"]').val(JSON.stringify({

			sessionToken: 	_self.sessionToken,
			token:   		_self.paymentMethod,
			amount:  		_self.amount,
			metaData:		metaData,
			email:			_self.$form.find('[name="' + _self.cardBillingFormNames.email + '"]').val(),
			confirm: 		0,
			data:			_self.getShowIntentData(_self.$form),
			customer:		customer,
			save:			save // 0 or 1 for more reliable transfer than bool

		}));

		$.ajax({

			type: 'POST',
			url: _self.path,
			data: _self.$form.serialize() 

		}).done(function(response) {

			_self.handleServerResponse(response.data);

		}).fail(function(jqXHR, textStatus, errorThrown) {
			
			console.log(jqXHR);
			
			// Allow an overriding message to be set; useful for form validation and custom errors
			if (typeof jqXHR.responseJSON !== 'undefined' && 
			    typeof jqXHR.responseJSON.message !== 'undefined' && 
				typeof jqXHR.responseJSON.data.intent !== 'undefined' && 
				jqXHR.responseJSON.data.intent == '_custom') {
				
				// Send back a 400 if you want to do a general error, otherwise server
				// This allows you do differentiate between errors that should remove the form or allow resubmission
				if (jqXHR.status === 400) {
				
					_self.onGeneralError(_self.$form, jqXHR.responseJSON.message);
					
				} else {
					
					_self.onServerError(_self.$form, jqXHR.responseJSON.message);	
					
				}
				
			} else {

				if (typeof jqXHR.responseJSON             !== 'undefined' &&
					typeof jqXHR.responseJSON.data    	  !== 'undefined' &&
					typeof jqXHR.responseJSON.data.intent !== 'undefined') {

					if (jqXHR.responseJSON.data.intent == '_server') {

						// .intent is not said so assume a server error
						_self.onServerError(_self.$form, _self.serverError);

					} else {

						// .intent should be a Stripe card error code
						_self.onGeneralError(_self.$form, _self.getError(jqXHR.responseJSON.data.intent));

					}

				} else {

					// .intent is not said so assume a server error
					_self.onServerError(_self.$form, _self.serverError);

				}
				
			}

		});

	}

}

module.exports = cubedStripe;
